import { render } from "./ValidatorCardV2.vue?vue&type=template&id=0c929e61&scoped=true"
import script from "./ValidatorCardV2.vue?vue&type=script&lang=js"
export * from "./ValidatorCardV2.vue?vue&type=script&lang=js"

import "./ValidatorCardV2.vue?vue&type=style&index=0&id=0c929e61&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c929e61"]])

export default __exports__